import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../../components/feature/Navbar';
import { Footer } from '../../components/feature/Footer';

export default function PortfolioPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    // Update page title and meta tags
    document.title = 'Portfolio | BusinessWebsitePro';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'View our portfolio of stunning websites. Real projects for restaurants, salons, tech companies, and more in Vancouver and beyond.');
    }

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'See Our Work: Award-Winning Business Websites | Results-Driven Designs | BWP');
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Explore our portfolio of award-winning business websites. See real results from our transparent, results-driven web design approach. View live demos and case studies.');
    }

    const twitterTitle = document.querySelector('meta[property="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', 'See Our Work: Award-Winning Business Websites | Results-Driven Designs | BWP');
    }

    const twitterDescription = document.querySelector('meta[property="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute('content', 'Explore our portfolio of award-winning business websites. See real results from our transparent, results-driven web design approach. View live demos and case studies.');
    }

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const projects = [
    {
      title: 'BookNManage',
      category: 'SaaS Platform',
      image: 'https://static.readdy.ai/image/afbb870fba5009b6251518206686e578/1c083fd93aef0df070a9d26cea165ef8.jpeg',
      description: 'All-in-one software solution for cleaning companies with WhatsApp scheduling, GPS vehicle tracking, 1-click invoicing, and financial dashboard',
      link: 'https://booknmanage.com/',
      isExternal: true
    },
    {
      title: 'Sherali Hassan Inc.',
      category: 'Accounting & Financial Services',
      image: 'https://static.readdy.ai/image/afbb870fba5009b6251518206686e578/462763966e61d34906da312fb3b4d320.jpeg',
      description: 'Professional CPA chartered accountant website offering comprehensive accounting solutions across British Columbia with expert financial guidance for business success',
      link: 'https://sheralihassan.businesswebsitepro.com/',
      isExternal: true
    },
    {
      title: 'Urban Life (U-Life)',
      category: 'Technical & Cleaning Services',
      image: 'https://static.readdy.ai/image/afbb870fba5009b6251518206686e578/18794c50e86dd7e59fe46c8de1562deb.jpeg',
      description: 'Professional technical and cleaning services platform in Dubai with online booking, service management, and customer support features',
      link: 'https://urbanlife.ae/',
      isExternal: true
    },
    {
      title: 'Bella Vista Restaurant',
      category: 'Restaurant',
      image: 'https://public.readdy.ai/ai/img_res/2544c7b33cedc2455c6db43433a10ffa.jpg',
      description: 'Modern restaurant website with online reservations and menu showcase',
      link: '/portfolio/bella-vista-restaurant',
      isExternal: false
    },
    {
      title: 'Urban Salon & Spa',
      category: 'Beauty & Wellness',
      image: 'https://readdy.ai/api/search-image?query=luxury%20salon%20website%20design%20displayed%20on%20tablet%2C%20beauty%20services%20booking%20interface%2C%20elegant%20spa%20website%20with%20appointment%20system%2C%20professional%20wellness%20web%20design%2C%20light%20background&width=800&height=600&seq=portfolio-salon&orientation=landscape',
      description: 'Elegant salon website with booking system and service gallery',
      link: '/portfolio/urban-salon-spa',
      isExternal: false
    },
    {
      title: 'TechFix Solutions',
      category: 'Technology Services',
      image: 'https://readdy.ai/api/search-image?query=professional%20IT%20services%20website%20on%20desktop%20computer%2C%20technology%20consulting%20web%20design%2C%20modern%20tech%20company%20interface%20with%20service%20offerings%2C%20clean%20business%20website%2C%20light%20background&width=800&height=600&seq=portfolio-tech&orientation=landscape',
      description: 'Professional IT services website with client portal',
      link: '/portfolio/techfix-solutions',
      isExternal: false
    },
    {
      title: 'Green Thumb Landscaping',
      category: 'Home Services',
      image: 'https://readdy.ai/api/search-image?query=landscaping%20company%20website%20design%20on%20laptop%2C%20outdoor%20services%20web%20interface%20with%20project%20gallery%2C%20professional%20lawn%20care%20website%2C%20nature-inspired%20design%2C%20light%20background&width=800&height=600&seq=portfolio-landscaping&orientation=landscape',
      description: 'Vibrant landscaping website with project portfolio',
      link: '',
      isExternal: false
    },
    {
      title: 'Boutique Fashion Store',
      category: 'E-Commerce',
      image: 'https://readdy.ai/api/search-image?query=modern%20fashion%20ecommerce%20website%20on%20computer%20screen%2C%20online%20clothing%20store%20interface%20with%20product%20catalog%2C%20stylish%20retail%20web%20design%2C%20shopping%20cart%20system%2C%20light%20background&width=800&height=600&seq=portfolio-fashion&orientation=landscape',
      description: 'Full e-commerce store with 200+ products and payment integration',
      link: '',
      isExternal: false
    },
    {
      title: 'Summit Law Group',
      category: 'Legal Services',
      image: 'https://readdy.ai/api/search-image?query=professional%20law%20firm%20website%20design%20on%20desktop%2C%20legal%20services%20web%20interface%20with%20attorney%20profiles%2C%20corporate%20legal%20website%2C%20trustworthy%20business%20design%2C%20light%20background&width=800&height=600&seq=portfolio-law&orientation=landscape',
      description: 'Professional law firm website with attorney profiles',
      link: '',
      isExternal: false
    },
    {
      title: 'Maple Realty',
      category: 'Real Estate',
      image: 'https://readdy.ai/api/search-image?query=real%20estate%20agency%20website%20on%20laptop%20screen%2C%20property%20listings%20interface%20with%20search%20functionality%2C%20modern%20realtor%20web%20design%2C%20professional%20housing%20website%2C%20light%20background&width=800&height=600&seq=portfolio-realty&orientation=landscape',
      description: 'Real estate website with property listings and search',
      link: '',
      isExternal: false
    },
    {
      title: 'Fitness First Gym',
      category: 'Health & Fitness',
      image: 'https://readdy.ai/api/search-image?query=modern%20gym%20website%20design%20on%20tablet%2C%20fitness%20center%20web%20interface%20with%20class%20schedules%20and%20membership%20plans%2C%20athletic%20wellness%20website%2C%20energetic%20design%2C%20light%20background&width=800&height=600&seq=portfolio-gym&orientation=landscape',
      description: 'Dynamic gym website with class schedules and membership plans',
      link: '',
      isExternal: false
    },
    {
      title: 'Artisan Coffee Co.',
      category: 'Food & Beverage',
      image: 'https://readdy.ai/api/search-image?query=coffee%20shop%20website%20design%20on%20computer%2C%20cafe%20web%20interface%20with%20menu%20and%20location%20info%2C%20artisan%20coffee%20brand%20website%2C%20warm%20inviting%20design%2C%20light%20background&width=800&height=600&seq=portfolio-coffee&orientation=landscape',
      description: 'Cozy coffee shop website with menu and location finder',
      link: '',
      isExternal: false
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />
      
      {/* Schema.org Structured Data for Portfolio */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          "name": "Website Design Portfolio - BusinessWebsitePro",
          "description": "View our portfolio of professional websites designed for businesses in Vancouver, BC, and across Canada. See real examples of our web design work.",
          "url": "https://businesswebsitepro.com/portfolio",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://businesswebsitepro.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Portfolio",
                "item": "https://businesswebsitepro.com/portfolio"
              }
            ]
          }
        })}
      </script>
      
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img 
            src="https://readdy.ai/api/search-image?query=stunning%20portfolio%20showcase%20display%20with%20multiple%20website%20mockups%20on%20various%20devices%20modern%20clean%20presentation%20professional%20web%20design%20gallery%20high%20quality%20digital%20screens%20elegant%20layout&width=1920&height=1080&seq=portfolio-hero-bg-001&orientation=landscape"
            alt="Web design portfolio showcase"
            className="w-full h-full object-cover object-center"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 drop-shadow-lg" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Our Portfolio
          </h1>
          <p className="text-xl sm:text-2xl text-white/90 mb-10 drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">
            Real websites. Real results. See how we've helped businesses across Canada grow their online presence.
          </p>
          
          {/* CTA Buttons - Bottom Right */}
          <div className="flex flex-wrap items-center justify-end gap-4 mt-8" style={{ marginTop: '150px' }}>
            <a
              href="/contact"
              className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-teal-500 to-cyan-500 text-white px-8 py-4 rounded-full font-bold text-lg hover:from-teal-600 hover:to-cyan-600 transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line text-xl"></i>
              Book Free Consultation
            </a>
            <a
              href="/pricing"
              className="inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white/20 transition-all duration-300 border border-white/20 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-price-tag-3-line text-xl"></i>
              View Pricing
            </a>
          </div>
        </div>
      </section>

      {/* Portfolio Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((project, index) => (
              <div 
                key={index}
                className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer border border-gray-100"
              >
                <div className="w-full h-64 overflow-hidden">
                  <img 
                    src={project.image} 
                    alt={project.title} 
                    className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <span className="inline-block bg-blue-100 text-[#0d3b66] text-xs font-semibold px-3 py-1 rounded-full mb-3">
                    {project.category}
                  </span>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">{project.title}</h3>
                  <p className="text-base text-gray-600 leading-relaxed mb-4">{project.description}</p>
                  {project.link ? (
                    project.isExternal ? (
                      <a 
                        href={project.link} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-[#0d3b66] font-semibold flex items-center gap-2 hover:gap-3 transition-all duration-300 cursor-pointer whitespace-nowrap"
                      >
                        Visit Website
                        <i className="ri-external-link-line"></i>
                      </a>
                    ) : (
                      <Link 
                        to={project.link}
                        className="text-[#0d3b66] font-semibold flex items-center gap-2 hover:gap-3 transition-all duration-300 cursor-pointer whitespace-nowrap"
                      >
                        View Demo
                        <i className="ri-arrow-right-line"></i>
                      </Link>
                    )
                  ) : (
                    <span className="text-gray-400 font-semibold flex items-center gap-2">
                      Coming Soon
                      <i className="ri-time-line"></i>
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-[#0d3b66] mb-4">Our Track Record</h2>
            <p className="text-xl text-gray-600">Numbers that speak for themselves</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <p className="text-5xl font-bold text-[#0d3b66] mb-3">300+</p>
              <p className="text-lg text-gray-600">Websites Delivered</p>
            </div>
            <div className="text-center">
              <p className="text-5xl font-bold text-[#0d3b66] mb-3">98%</p>
              <p className="text-lg text-gray-600">Client Satisfaction</p>
            </div>
            <div className="text-center">
              <p className="text-5xl font-bold text-[#0d3b66] mb-3">15 Days</p>
              <p className="text-lg text-gray-600">Average Delivery</p>
            </div>
            <div className="text-center">
              <p className="text-5xl font-bold text-[#0d3b66] mb-3">24/7</p>
              <p className="text-lg text-gray-600">AI Assistant Available</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
